var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 200,
    viewBox: "0 0 192 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 48C113.255 48 124 37.2548 124 24C124 10.7452 113.255 0 100 0C86.7452 0 76 10.7452 76 24C76 37.2548 86.7452 48 100 48Z",
    fill: "#3E70DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 116C186.627 116 192 110.627 192 104C192 97.3726 186.627 92 180 92C173.373 92 168 97.3726 168 104C168 110.627 173.373 116 180 116Z",
    fill: "#3E70DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 176C163.732 176 170 169.732 170 162C170 154.268 163.732 148 156 148C148.268 148 142 154.268 142 162C142 169.732 148.268 176 156 176Z",
    fill: "#3E70DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 200C108.837 200 116 192.837 116 184C116 175.163 108.837 168 100 168C91.1634 168 84 175.163 84 184C84 192.837 91.1634 200 100 200Z",
    fill: "#3E70DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 180C53.9411 180 62 171.941 62 162C62 152.059 53.9411 144 44 144C34.0589 144 26 152.059 26 162C26 171.941 34.0589 180 44 180Z",
    fill: "#3E70DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 124C31.0457 124 40 115.046 40 104C40 92.9543 31.0457 84 20 84C8.9543 84 0 92.9543 0 104C0 115.046 8.9543 124 20 124Z",
    fill: "#3E70DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69C56.1503 69 66 59.1503 66 47C66 34.8497 56.1503 25 44 25C31.8497 25 22 34.8497 22 47C22 59.1503 31.8497 69 44 69Z",
    fill: "#3E70DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158 61C163.523 61 168 56.5228 168 51C168 45.4772 163.523 41 158 41C152.477 41 148 45.4772 148 51C148 56.5228 152.477 61 158 61Z",
    fill: "#3E70DA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.f4a5fcf9d6d053efc1d57e1182573293.svg";
export { ForwardRef as ReactComponent };